module.exports = __webpack_public_path__ + "img/img_gywm.80f580f1.png";